'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dynamic = function dynamic() {
  return import('@/page/dynamic');
};
var dynamicList = function dynamicList() {
  return import('@/page/dynamic/dynamic-list');
};
var dynamicDetail = function dynamicDetail() {
  return import('@/page/dynamic/information-detail');
};
var concatDetail = function concatDetail() {
  return import('@/page/dynamic/concat-detail');
};
var teacherDetail = function teacherDetail() {
  return import('@/page/dynamic/teacher-detail');
};

exports.default = [{
  path: '/dynamic',
  name: 'dynamic',
  component: dynamic,
  children: [{
    path: '/dynamicList',
    name: 'dynamicList',
    component: dynamicList
  }, {
    path: 'dynamicDetail',
    name: 'dynamicDetail',
    component: dynamicDetail
  }]
}, {
  path: '/concatDetail',
  name: 'concatDetail',
  component: concatDetail
}, {
  path: '/teacherDetail',
  name: 'teacherDetail',
  component: teacherDetail
}];